import type { GenericHandlerValues } from '@/models'
import { useGenericRequestHandler } from '../../../handlers'

export type UseMoteTranscriptTranslateMutation = GenericHandlerValues<
  {
    outputText: string
  } | null,
  'POST'
>

export const useMoteTranscriptTranslateMutation =
  (): UseMoteTranscriptTranslateMutation => {
    return useGenericRequestHandler({
      route: `v1/m/translate`,
      method: 'POST'
    }) as UseMoteTranscriptTranslateMutation
  }
